import { Button } from "react-bootstrap";
import styled from "styled-components";

export default styled(Button)`
    margin-right: 7px;
    padding-left: 5px;
    padding-right: 7px;
`;
